/* istanbul ignore file */

export var CLOSE_TIMEOUT_MS = process.env.NODE_ENV === 'test' ? 0 : 250;